/* Keep the campaign coupon on Shopify's real Ajax cart, not just the PDP preview. */
(function (window, document) {
  'use strict';
  var override;
  var queue = Promise.resolve();
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  function stored(storage, name) {
    try { return window[storage].getItem(name) || ''; } catch (_) { return ''; }
  }

  function code() {
    if (override !== undefined) return override;
    var fromUrl = '';
    new URLSearchParams(window.location.search).forEach(function (value, key) {
      if (key.trim().toLowerCase() === 'discount') fromUrl = value.trim();
    });
    if (fromUrl) return fromUrl;
    var saved = stored('localStorage', 'fastrrCouponCode') || stored('sessionStorage', 'pending_discount_code');
    if (saved) return saved.trim();
    var cookie = document.cookie.match(/(?:^|;\s*)discount_code=([^;]*)/);
    try { return cookie ? decodeURIComponent(cookie[1]).trim() : ''; } catch (_) { return ''; }
  }

  function request(path, body) {
    var controller = new AbortController();
    var timer = window.setTimeout(function () { controller.abort(); }, 6000);
    return window.fetch(root + path, {
      method: body === undefined ? 'GET' : 'POST',
      credentials: 'same-origin',
      cache: 'no-store',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: body === undefined ? undefined : JSON.stringify(body),
      signal: controller.signal
    }).then(function (response) {
      if (!response.ok) throw new Error('Cart request failed');
      return response.json();
    }).then(function (cart) {
      if (!Array.isArray(cart.items) || !Number.isFinite(cart.total_price)) throw new Error('Invalid cart response');
      return cart;
    }).finally(function () { window.clearTimeout(timer); });
  }

  function status(message) {
    document.querySelectorAll('.tt-shopcart-table01, .tt-cart-total-row').forEach(function (anchor) {
      var note = anchor.parentNode.querySelector('[data-vaku-cart-discount-status]');
      if (!note) {
        note = document.createElement('p');
        note.setAttribute('data-vaku-cart-discount-status', '');
        note.setAttribute('role', 'status');
        note.style.cssText = 'font-size:12px;line-height:1.5;margin:8px 0;';
        anchor.insertAdjacentElement('afterend', note);
      }
      note.textContent = message;
      note.hidden = !message;
    });
  }

  function money(amount) {
    return window.Shopify.formatMoney(amount, window.money_format);
  }

  function price(original, final, subtotal) {
    var cls = 'tt-price' + (subtotal ? ' subtotal' : '');
    return (original !== final ? '<div class="' + cls + ' tt-price-old">' + money(original) + '</div>' : '') +
      '<div class="' + cls + '">' + money(final) + '</div>';
  }

  function render(cart) {
    var rows = document.querySelectorAll('.tt-shopcart-table--js tbody > tr');
    // Coupon application does not change quantities. Never patch another line after a concurrent cart edit.
    var sameLines = rows.length === cart.items.length && Array.from(rows).every(function (row, index) {
      var input = row.querySelector('input[name="updates[]"]');
      return input && input.id === 'updates_' + cart.items[index].variant_id;
    });
    if (document.querySelector('.tt-empty-cart-js') && !sameLines) {
      // A gift/split-line discount or another tab changed cart membership. Rehydrate from Shopify once.
      window.location.reload();
      return;
    }
    var compatible = sameLines && Array.from(rows).every(function (row, index) {
      return Number(row.querySelector('input[name="updates[]"]').value) === cart.items[index].quantity;
    });
    if (compatible) {
      rows.forEach(function (row, index) {
        var item = cart.items[index];
        row.querySelectorAll('.item__original-price').forEach(function (node) {
          node.innerHTML = price(item.original_price, item.final_price, false);
        });
        row.querySelectorAll('.item__subtotal-price').forEach(function (node) {
          node.innerHTML = price(item.original_line_price, item.final_line_price, true);
        });
        row.querySelectorAll('.discounts__item').forEach(function (node) {
          node.textContent = '';
          (item.discounts || []).forEach(function (discount) {
            var li = document.createElement('li');
            li.className = 'discounts__discount';
            li.textContent = discount.title;
            node.appendChild(li);
          });
        });
      });
      var subtotal = document.querySelector('#subtotal td');
      var total = document.querySelector('#grandtotal td');
      if (subtotal) {
        subtotal.innerHTML = money(cart.original_total_price);
        subtotal.setAttribute('data-total-price', cart.total_price);
      }
      if (total) total.innerHTML = money(cart.total_price);
      var savings = document.querySelector('#discounts__foot');
      if (savings) {
        savings.style.display = cart.total_discount > 0 ? '' : 'none';
        savings.querySelector('td').innerHTML = '-' + money(cart.total_discount);
      }
      // A previously calculated shipping estimate may no longer apply to the new cart/discount.
      ['#tax', '#wrapper-response'].forEach(function (selector) {
        var node = document.querySelector(selector);
        if (node) node.style.display = 'none';
      });
    }
    if (window.addToCartHandler) {
      document.querySelectorAll('header .tt-cart-list').forEach(function (list) { list.textContent = ''; });
      cart.items.slice().reverse().forEach(function (item) { window.addToCartHandler.addItem(item); });
      window.addToCartHandler.updateGeneralInfo(cart);
      if (!cart.item_count && window.jQuery) {
        window.jQuery('.tt-cart-empty').removeClass('hide');
        window.jQuery('.tt-cart-box').addClass('hide');
      }
    }
    if (window.jQuery) window.jQuery('body').trigger('refreshCurrency');
    var selected = code();
    var applicable = (cart.discount_codes || []).some(function (discount) {
      return discount.code.toLowerCase() === selected.toLowerCase() && discount.applicable;
    });
    status(!selected || !cart.item_count ? '' : applicable ? 'Coupon ' + selected + ' applied.' : 'This coupon does not apply to the current cart.');
  }

  function hasCode(cart, selected) {
    return (cart.discount_codes || []).some(function (discount) {
      return discount.code.toLowerCase() === selected.toLowerCase();
    });
  }

  function sync() {
    var operation = queue.catch(function () {}).then(async function () {
      var selected = code();
      if (selected) status('Applying your offer…');
      var cart = await request('cart.js');
      for (var attempt = 0; attempt < 3; attempt++) {
        selected = code();
        if (selected && !hasCode(cart, selected)) {
          // The selected campaign is the same single coupon handed to Fastrr. Shopify owns eligibility and amounts.
          cart = await request('cart/update.js', { discount: selected });
        }
        if (selected === code()) {
          render(cart);
          return cart;
        }
      }
      throw new Error('Coupon changed during validation');
    });
    queue = operation;
    return operation.catch(function (error) {
      status('We could not verify your offer. Checkout will confirm the final price.');
      throw error;
    });
  }

  function properties(item) {
    var values = item.properties || {};
    return JSON.stringify(Object.keys(values).sort().map(function (key) { return [key, values[key]]; }));
  }

  function addedLine(cart, added) {
    return cart.items.find(function (item) { return item.key === added.key; }) || cart.items.find(function (item) {
      var plan = function (line) { return line.selling_plan_allocation && line.selling_plan_allocation.selling_plan.id; };
      return item.variant_id === added.variant_id && properties(item) === properties(added) && plan(item) === plan(added);
    }) || added;
  }

  window.VakuCartDiscount = {
    sync: sync,
    render: render,
    addedLine: addedLine,
    setCode: function (selected) {
      override = String(selected || '').trim();
      return sync();
    }
  };
  function ready() { if (code()) sync().catch(function () {}); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', ready, { once: true });
  else ready();
})(window, document);
